import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { MarketData } from 'app/models/MarketData';
import { PopupLoginComponent } from 'app/modules/popup-login/popup-login.component';
import { PopupWatchlistComponent } from 'app/modules/popup-watchlist/popup-watchlist.component';
import { AbsPipe } from 'app/shared/abs.pipe';
import { DataService } from 'app/shared/data.service';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { map, of, switchMap } from 'rxjs';

@Component({
    selector: 'app-watchlist',
    standalone: true,
    imports: [CommonModule, MatIconModule, AbsPipe, RouterModule],
    templateUrl: './watchlist.component.html',
})
export class WatchlistComponent implements OnInit {
    isLoggedIn?: boolean;
    watchlist: MarketData[][];
    page: number = 0;
    pageLength: number = 3;

    constructor(@Inject(PLATFORM_ID) private platformId,
        private loginService: LoginService,
        private utilisateurService: UtilisateurService,
        private dataService: DataService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog, private router:Router
    ) {
        this.isLoggedIn = this.loginService.getIsLogged();
    }

    ngOnInit(): void {
        this.loadWatchlist();
    }

    private loadWatchlist() {
        if (this.isLoggedIn !== undefined) {
            if (this.isLoggedIn)
                this.utilisateurService
                    .getUtilisateurByUsername(this.loginService.getUsername())
                    .pipe(
                        switchMap((utilisateurs) => {
                            if (utilisateurs[0]?.watchlist.length > 0) {
                                return this.dataService
                                    .recupererTout()
                                    .pipe(
                                        map((data) =>
                                            data.filter((item) =>
                                                utilisateurs[0].watchlist.includes(
                                                    item.referentiel.stockName
                                                )
                                            )
                                        )
                                    );
                            }
                            return of([] as MarketData[]);
                        })
                    )
                    .subscribe((watchlistArray) => {
                        const watchlistMatrix = [];
                        for (
                            let i = 0;
                            i < watchlistArray.length;
                            i += this.pageLength
                        ) {
                            watchlistMatrix.push(
                                watchlistArray.slice(i, i + this.pageLength)
                            );
                        }
                        this.watchlist = watchlistMatrix;
                        this.cdr.markForCheck();
                    });
            else this.watchlist = [];
        }
    }

    openWatchlist() {
        if (!this.isLoggedIn) this.dialog.open(PopupLoginComponent);
        else {
            this.dialog.open(PopupWatchlistComponent);
            this.dialog.afterAllClosed.subscribe(() => {
                this.loadWatchlist();
            });
        }
    }

    lastPage() {
        this.page--;
        this.cdr.markForCheck();
    }

    nextPage() {
        this.page++;
        this.cdr.markForCheck();
    }
    reloadPage(stockName:string,isin :string): void {
               if (isPlatformBrowser(this.platformId)) {
        
        this.router.navigate(['/actifs', stockName,isin])
          .then(() => {
            window.location.reload();
          });
      }
    }
}
